import { SET_SEARCH_WORD } from './searchActionTypes';

export const setSearchWord = (payload) => {
    return ({
        type: SET_SEARCH_WORD,
        payload,
    });
}
